<script setup>
import {computed, nextTick, onMounted, ref, watch} from 'vue'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import Button from "primevue/button";
import EmbedMap from "./EmbedMap.vue";

const props = defineProps({
    location: Object,
    theming: Object,
    theme: Object
})

const serviceName = computed(() => {
    if (props.location.type === 'in_person') {
        const a = JSON.parse(props.location.address)?.address;

        let address = [];
        if (a?.road)
            address.push(a?.road + (a?.house_number ? ' ' + a?.house_number : ''))

        if (a?.town)
            address.push(a?.town)

        if (a?.country)
            address.push(a?.country)
        return address.join(', ');
    }
    switch (props.location.service) {
        case 'ms_teams':
            return 'Microsoft Teams';
        case 'phone_call':
            return 'Telefonní hovor';
        case 'google_meet':
            return 'Google Meet';
        case 'whatsapp':
            return 'WhatsApp';
        default:
            const a = JSON.parse(props.location.address)?.address;

            let address = [];
            if (a?.road)
                address.push(a?.road + (a?.house_number ? ' ' + a?.house_number : ''))

            if (a?.town)
                address.push(a?.town)

            if (a?.country)
                address.push(a?.country)
            return address.join(', ');
    }
})

const serviceIcon = computed(() => {
    if (props.location.type === 'in_person') {
        return 'pi pi-map-marker';
    }

    switch (props.location.service) {
        case 'ms_teams':
            return 'bi bi-microsoft-teams';
        case 'google_meet':
            return 'pi pi-google';
        case 'whatsapp':
            return 'bi bi-whatsapp';
        case 'phone_call':
            return 'pi pi-phone';
        default:
            return 'pi pi-map-marker';
    }
})

const model = defineModel()

onMounted(() => {
    model.value = props.location.id;
})
</script>

<template>
    <div
        class="shadow border overflow-hidden relative h-[100px] transition-all my-4 " :class="[theming]">
        <div class="p-4 flex gap-2 items-center absolute z-20 backdrop-blur-sm bottom-0 pr-8 h-full"
             :class="location.type === 'in_person' ? 'bg-white/30 ':`bg-${theme.color}-50 bg-opacity-70`">
            <i :class="`${serviceIcon} text-${theme.color}-500 mx-2`"></i>
            <div class="grow">
                <p class="font-semibold">{{ location.name }}</p>
                <p class="text-xs">{{ serviceName }}</p>
            </div>
        </div>
        <div v-if="location.type === 'in_person'" class="map-container absolute z-10">
            <EmbedMap :coordinates="{ lat: location.latitude, lng: location.longitude }" :pan="[-100,0]" :height="100" :color="theme.color"/>
        </div>
        <div v-else class="absolute z-10  w-full h-full" :class="`bg-${theme.color}-50`">
            <div class="flex flex-col justify-center flex-wrap gap-0 -ml-5 opacity-50 -mt-2">
                <div v-for="rowIndex in 12" :key="rowIndex" class="flex justify-center gap-4"
                     :class="{'ml-8': rowIndex % 2 === 1}">
                    <i v-for="i in 80" :key="i" :class="`${serviceIcon} text-${theme.color}-500  -rotate-45`"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.map-container {
    height: 100px;
    position: relative;
}

</style>
